import { Datatype } from '../../../../expressions/datatype/Datatype';
import {
  IReference,
  ReferenceType,
} from '../../../../expressions/references/IReference';
import { IReferencePath } from '../../../../expressions/references/IReferencePath';
import { ConfirmWidgetValue, IConfirmWidget } from './IConfirmWidget';

export function getConfirmWidgetReference(
  path: IReferencePath,
  widget: IConfirmWidget,
): IReference {
  return {
    type: ReferenceType.Widget,
    widgetType: widget.type,
    code: widget.code,
    path,
    id: widget.id,
    label: widget.code,
    field: {
      type: Datatype.Number,
      options: [
        {
          value: ConfirmWidgetValue.Unconfirmed,
          label: 'Non confermato né modificato',
        },
        {
          value: ConfirmWidgetValue.Editing,
          label: 'In modifica',
        },
        {
          value: ConfirmWidgetValue.ConfirmedDefault,
          label: 'Confermato',
        },
        {
          value: ConfirmWidgetValue.ConfirmedModified,
          label: 'Modificato',
        },
      ],
    },
  };
}
